import { Plus, Building2 } from 'lucide-react';
import { ShortcutButton } from '@/components/keyboard/ShortcutIndicator';

interface FundsEmptyStateProps {
  onCreateFund: () => void;
}

export function FundsEmptyState({ onCreateFund }: FundsEmptyStateProps) {
  return (
    <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
      <Building2 className="mx-auto h-12 w-12 text-gray-400" />
      <h3 className="mt-2 text-sm font-medium text-gray-900">No funds</h3>
      <p className="mt-1 text-sm text-gray-500">
        Get started by creating your first fund.
      </p>
      <div className="mt-6">
        <ShortcutButton
          shortcut={{ key: 'n' }}
          className="flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
          onClick={onCreateFund}
        >
          <Plus className="h-4 w-4" />
          Create New Fund
        </ShortcutButton>
      </div>
    </div>
  );
}
